import { actions } from './actions'

const initialState = {
  cpsConflictivos: {
    data: [],
    loading: false,
    error: '',
  },
}

export default function codigosPostalesConflictivosReducer(state = initialState, action) {
  switch (action.type) {
    case actions.CP_CONFLICTIVO_LOAD_REQUESTED:
      return { ...state, cpsConflictivos: { ...state.cpsConflictivos, loading: true } }
    case actions.CP_CONFLICTIVO_LOAD_SUCCEEDED:
      return {
        ...state,
        cpsConflictivos: { ...state.cpsConflictivos, data: action.payload, loading: false },
      }
    case actions.CP_CONFLICTIVO_LOAD_FILED:
      return {
        ...state,
        cpsConflictivos: { ...state.cpsConflictivos, loading: false, error: action.error },
      }
    case actions.CP_CONFLICTIVO_UPDATE_REQUESTED:
      return {
        ...state,
        cpsConflictivos: { ...state.cpsConflictivos, loading: true, error: '' },
      }
    case actions.CP_CONFLICTIVO_UPDATE_SUCCEEDED:
      return {
        ...state,
        cpsConflictivos: {
          ...state.cpsConflictivos,
          data: state.cpsConflictivos.data.map(cp =>
            cp.id === action.payload.id ? action.payload : cp,
          ),
          loading: false,
          error: '',
        },
      }
    case actions.CP_CONFLICTIVO_UPDATE_FILED:
      return {
        ...state,
        cpsConflictivos: { ...state.cpsConflictivos, loading: false, error: action.error },
      }
    case actions.CP_CONFLICTIVO_INSERT_REQUESTED:
      return {
        ...state,
        cpsConflictivos: { ...state.cpsConflictivos, loading: true, error: '' },
      }
    case actions.CP_CONFLICTIVO_INSERT_SUCCEEDED:
      return {
        ...state,
        cpsConflictivos: {
          ...state.cpsConflictivos,
          data: [].concat(action.payload, state.cpsConflictivos.data),
          loading: false,
          error: '',
        },
      }
    case actions.CP_CONFLICTIVO_INSERT_FILED:
      return {
        ...state,
        cpsConflictivos: { ...state.cpsConflictivos, loading: false, error: action.error },
      }
    default:
      return state
  }
}
